import { ColumnDef } from '@tanstack/react-table';
import { t } from 'i18next';
import { Hash } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import {
  DataTableFilter,
  RowDataWithActions,
} from '@/components/ui/data-table';
import { DataTableColumnHeader } from '@/components/ui/data-table/data-table-column-header';
import { AdminMcp } from '@activepieces/shared';

import { CellWithCopyTooltip, PieceIconsCell } from './admin-table-cells';

export const useAdminMcpsTable = () => {
  const columns: ColumnDef<RowDataWithActions<AdminMcp>>[] = [
    {
      accessorKey: 'name',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('Name')} />
      ),
      cell: ({ row }) => (
        <CellWithCopyTooltip
          displayValue={row.original.name}
          tooltipValue={row.original.id}
        />
      ),
    },
    {
      accessorKey: 'types',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('Type')} />
      ),
      cell: ({ row }) => (
        <div className="flex gap-1">
          {row.original.types.map((type) => (
            <Badge
              key={type}
              variant="outline"
              className={
                type === 'PIECE'
                  ? 'bg-primary/10 text-primary border-primary/20'
                  : 'bg-purple-100 text-purple-700 border-purple-200'
              }
            >
              {type.toLowerCase()}
            </Badge>
          ))}
        </div>
      ),
    },
    {
      accessorKey: 'pieceNames',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('Apps')} />
      ),
      cell: ({ row }) => (
        <PieceIconsCell pieceNames={row.original.pieceNames} maxIcons={3} />
      ),
    },
    {
      accessorKey: 'externalIds',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('User ID')} />
      ),
      cell: ({ row }) =>
        row.original.externalIds.length > 0
          ? row.original.externalIds.join(', ')
          : 'N/A',
    },
    {
      accessorKey: 'externalCustomerId',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('Client ID')} />
      ),
      cell: ({ row }) => row.original.externalCustomerId ?? 'N/A',
    },
  ];

  const filters: DataTableFilter<keyof AdminMcp>[] = [
    {
      type: 'input',
      title: t('Search'),
      accessorKey: 'name',
      options: [],
    },
    {
      type: 'input',
      title: t('User ID'),
      accessorKey: 'externalIds',
      icon: Hash,
      options: [],
    },
    {
      type: 'input',
      title: t('Client ID'),
      accessorKey: 'externalCustomerId',
      icon: Hash,
      options: [],
    },
  ];

  return { columns, filters };
};
